import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import moment from 'moment';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CassBillTypeConflict } from '../../../data/cass-accounts.service';

export interface ICassAccountWarningsData {
  accountNumber: string;
  loadBills: () => Observable<CassBillTypeConflict[]>;
}

@Component({
  selector: 'exa-cass-account-warnings-dialog',
  template: `
    <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="start center">
      <mat-icon class="align--middle margin--right warnings__title-icon">warning</mat-icon>
      <span>Warnings</span>
    </h1>
    <div mat-dialog-content>
      <p>
        These bills of account <strong>{{data.accountNumber}}</strong> were matched to the other account type
        (a Distributor account receiving a Supplier bill, or a Supplier account receiving a Distributor bill).
      </p>

      <div *ngIf="loading" class="warnings__loading">
        <mat-spinner diameter="24"></mat-spinner>
        <span>Loading bills...</span>
      </div>
      <p *ngIf="error" class="text--warn">The bills could not be loaded, please try again.</p>

      <ng-container *ngIf="bills">
        <table class="warnings__table" *ngIf="bills.length; else noBills">
          <thead>
            <tr>
              <th>Bill Number</th>
              <th>Account Number</th>
              <th>Begin Date</th>
              <th>End Date</th>
              <th>Process Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let bill of bills">
              <td>{{bill.id}}</td>
              <td>{{bill.account_number}}</td>
              <td>{{formatDate(bill.begin_date)}}</td>
              <td>{{formatDate(bill.end_date)}}</td>
              <td>{{formatDate(bill.process_date)}}</td>
            </tr>
          </tbody>
        </table>
        <ng-template #noBills>
          <p>This account has no warnings.</p>
        </ng-template>
      </ng-container>
    </div>
    <div mat-dialog-actions class="warnings__actions">
      <button mat-button class="warnings__button" (click)="dialogRef.close()">Close</button>
    </div>
  `,
  styles: [`
    .warnings__title-icon {
      color: #ef6c00;
    }

    .warnings__loading {
      display: flex;
      align-items: center;
      margin: 16px 0;
      color: #757575;
    }

    .warnings__loading span {
      margin-left: 12px;
    }

    .warnings__table {
      width: 100%;
      margin-bottom: 16px;
      border-collapse: collapse;
      font-size: 13px;
    }

    .warnings__table th,
    .warnings__table td {
      padding: 6px 8px;
      border-bottom: 1px solid #e0e0e0;
      text-align: left;
      white-space: nowrap;
    }

    .warnings__table th {
      font-weight: 500;
      color: #757575;
    }

    .warnings__actions {
      display: flex;
      justify-content: flex-end;
    }

    .warnings__button {
      min-width: 100px;
    }
  `],
})
export class CassAccountWarningsDialogComponent implements OnInit {
  loading = false;
  error = false;
  bills: CassBillTypeConflict[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ICassAccountWarningsData,
    public dialogRef: MatDialogRef<CassAccountWarningsDialogComponent>,
  ) { }

  ngOnInit() {
    this.loading = true;

    this.data.loadBills()
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        bills => this.bills = bills,
        () => this.error = true,
      );
  }

  formatDate(value: string) {
    return value ? moment(value).format('MM/DD/YYYY') : '';
  }
}
